import { css, Theme } from "@emotion/react";

import { animationDuration } from "../../styles";

export const headerLayoutStyles = {
  header: (theme: Theme) =>
    css({
      position: "sticky",
      zIndex: theme.zIndex.appBar,
      willChange: "top, box-shadow",
      transition: `box-shadow ${animationDuration}s ease`,
    }),
  pageHeaderContainer: (theme: Theme, zIndexMod = 0) =>
    css({
      zIndex: theme.zIndex.appBar + zIndexMod,
      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
    }),
  pageStickyHeader: css({
    "> *": {
      transition: `opacity ${animationDuration}s ease`,
      visibility: "hidden",
      opacity: 0,
    },
  }),
};
